import type { FlowChainRow } from "@/types/flow"

/** candidate (или цепочка внутри него) ссылается на target. Цикл в данных обрывается. */
function chainReferences(chains: FlowChainRow[], chainId: number, targetId: number, seen: Set<number>): boolean {
  if (chainId === targetId) return true
  if (seen.has(chainId)) return false

  seen.add(chainId)
  const chain = chains.find((item) => item.id === chainId)
  if (!chain) return false
  return (chain.uses_chain_ids ?? []).some((id) => chainReferences(chains, id, targetId, seen))
}

/** В редакторе шаблона нельзя поставить саму цепочку и тех, кто на неё уже ссылается. */
export function placeableFlowChains(chains: FlowChainRow[], editingChainId: number | null): FlowChainRow[] {
  if (editingChainId == null) return chains
  return chains.filter((chain) => !chainReferences(chains, chain.id, editingChainId, new Set()))
}
